<template>
  <div class="footer-contact">
    <div class="footer-contact__heading">
      {{ $t('Contact') }}
    </div>

    <div class="footer-contact__group">
      <a
        href="tel:+31202382160"
        class="footer-contact__link"
      >
        <IconPhone class="icon icon--phone" />
        <span>020 - 23 82 160</span>
      </a>

      <span class="footer-contact__link">
        <span class="icon icon--open" />
        <span>{{ $t('mo - fr 09:00 - 17:00') }}</span>
      </span>
    </div>

    <a
      :href="`mailto:${$t('customerservice@dille-kamille.com')}`"
      class="footer-contact__link"
    >
      <IconEmail class="icon icon--phone" />
      <span>{{ $t('customerservice@dille-kamille.com') }}</span>
    </a>
  </div>
</template>

<style src="~layers/app/components/Footer/Contact.css" />
